import React from 'react';

class PerPageSelector extends React.Component {

  state = {
    url: '',
    per: 20
  }

  componentDidMount() {
    const url = new URL(window.location.href)
    const per = url.searchParams.get('per') || this.state.per

    this.setState({url, per})
  }

  onPerPageChange = (e) => {
    let url = this.state.url
    url.searchParams.set('per', e.target.value)

    window.location.href = url
  }

  render() {
    return (
      <div className='Pagination__right'>
        <p>Show per page</p>
        <select className='Select' onChange={this.onPerPageChange} value={this.state.per}>
          <option>20</option>
          <option>50</option>
          <option>100</option>
        </select>
      </div>
    );
  }
}

export default PerPageSelector
